import React, { Component } from 'react';
import axios from 'axios'
import FacebookIcon from 'react-share/es/FacebookIcon'
import VKIcon from 'react-share/es/VKIcon'
import OKIcon from 'react-share/es/OKIcon'
import FacebookShareButton from 'react-share/es/FacebookShareButton'
import VKShareButton from 'react-share/es/VKShareButton'
import OKShareButton from 'react-share/es/OKShareButton'
import { withRouter } from "react-router-dom";
import Select, { components } from 'react-select'
import names from './names'
import './card.css'
import Leafs from '../../components/leafs';
import { base } from '../../config'
import { baseHusky } from '../../config'
import { getParameterByName } from "../../helpers";
import ReactGA from 'react-ga';

/**** Cards *****/
// import c1 from '../../cards/c1-2.png'
// import c2 from '../../cards/c2-2.png'
// import c3 from '../../cards/c3-2.png'
// import c4 from '../../cards/c4-2.png'
// import c5 from '../../cards/c5-2.png'
// import c6 from '../../cards/c6-2.png'
// import c7 from '../../cards/c7-2.png'
// import c8 from '../../cards/c8-2.png'
// import c9 from '../../cards/c9-2.png'
// import c10 from '../../cards/c10-2.png'
// import c11 from '../../cards/c11-2.png'
// import c12 from '../../cards/c12-2.png'
// import c13 from '../../cards/c13-2.png'
// import c14 from '../../cards/c14-2.png'
// import c15 from '../../cards/c15-2.png'
// import c16 from '../../cards/c16-2.png'
// import c17 from '../../cards/c17-2.png'

// const cards = [
//   false, c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15, c16, c17,
// ]

import c21 from '../../cards/c21.png'
import c22 from '../../cards/c22.png'
import c23 from '../../cards/c23.png'
import c24 from '../../cards/c24.png'
import c25 from '../../cards/c25.png'
import c26 from '../../cards/c26.png'
import c27 from '../../cards/c27.png'
import c28 from '../../cards/c28.png'
import c29 from '../../cards/c29.png'
import c210 from '../../cards/c210.png'
import c211 from '../../cards/c211.png'
import c212 from '../../cards/c212.png'
import c213 from '../../cards/c213.png'
import c214 from '../../cards/c214.png'
import c215 from '../../cards/c215.png'
import c216 from '../../cards/c216.png'

const cards = [
  false, c21, c22, c23, c24, c25, c26, c27, c28, c29, c210, c211, c212, c213, c214, c215, c216,
]
const cardsNums = [
  false, 21, 22, 23, 24, 25, 26, 27, 28, 29, 210, 211, 212, 213, 214, 215, 216,
]

var socnet = '';
var openerState = {};
var socWin;

class Card extends Component {
  state = {
    card: null,
    name: '',
    nameVal: '',
    animated: false,
    createdImage: null,
    token: null,
    uid: null,
    soc: null,
    random: null
  }

  componentDidMount() {
    this.setState({random: this.randomString()})

    ReactGA.pageview(window.location.pathname + window.location.search);

    let token  = getParameterByName('token', window.location.href)
    if (!token) token = sessionStorage.getItem('token')
    const created = localStorage.getItem('cardImage')
    const uid = localStorage.getItem('cardUid')
    const card = localStorage.getItem('cardNum')

    if(window.opener != null && document.referrer.indexOf('mir.championat.com') > -1) {

      const { card, name, nameVal, animated, createdImage, token, uid, random } = window.opener.openerState
      const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`
      const downloadUrl = uid ? `${baseHusky}/m/${uid}/d/` : `${baseHusky}/m/2${card}/d/?${random}`
      var url = '';
      var vkImage = createdImage ? createdImage : `https://master.mirbackend.huskyjam.com/static/cards/VK/${card}.png?${random}`

      switch( window.opener.socnet ) {
        case 'VK':
          url  = 'http://vk.com/share.php?';
          url += 'url='          + encodeURIComponent(shareUrl);
          url += '&title='       + encodeURIComponent('Зафутболь открытку к 8 марта');
          url += '&image='       + encodeURIComponent(vkImage);
          url += '&noparse=true';
        break;

        case 'FB':
          url  = 'http://www.facebook.com/sharer.php?';
          url += 'u=' + encodeURIComponent(shareUrl);
        break;

        case 'OK':
          url  = 'https://connect.ok.ru/offer';
          url += '?url=' + encodeURIComponent(shareUrl);
        break;
      }
      window.location.href = url;
    }

    if (token && uid) {
      const config =  {
        headers: {
          Authorization: 'JWT ' + token,
        },
      }
      axios.post(`${base}/m/link/`, {uid}, config).then(res => {
        console.log(res)
      }).catch(err => {
        console.error(err)

      })
    }
    this.setState({ token, createdImage: created || null, uid: uid || null })
    console.log(created)

    if (!created) {
      this.getRandomCard()
    } else {
      this.setState({card})
    }
    setTimeout(() => {
      this.setState({animated: true})
    }, 200)
  }

  goToEnd = () => {
    localStorage.removeItem('cardNum')
    localStorage.removeItem('cardUid')
    localStorage.removeItem('cardImage')
    this.props.history.push('/end')

  }

  randomString = () => {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  checkShare = () => {
    const { card, uid, soc, random } = this.state
    const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`
    const downloadUrl = uid ? `${baseHusky}/m/${uid}/d/` : `${baseHusky}/m/2${card}/d/?${random}`

    //console.log('shareUrl', shareUrl);
    //console.log(`${baseHusky}/share/count/?social=fb&url=${shareUrl}`);

    switch(soc) {
      case 'FB':
        axios.get(`${baseHusky}/share/count/?social=fb&url=${shareUrl}`).then(res => {
          console.log(res)
          if (res.data > 0) {
            this.goToEnd()
          }
        }).catch((err) => {
          console.error(err)
        })
        break;
      case 'OK':
        axios.get(`${baseHusky}/share/count/?social=ok&url=${shareUrl}`).then(res => {
          console.log(res)
          if (res.data > 0) {
            this.goToEnd()
          }
        }).catch((err) => {
          console.error(err)
        })
        break;

      case 'VK':

          axios.get(`${baseHusky}/share/count/?social=vk&url=${shareUrl}`).then(res => {
            console.log(res)
            if (res.data > 0) {
              this.goToEnd()
            }
          }).catch((err) => {
            console.error(err)
          })
        break;
      default:
        console.error('no social')
    }

  }

  getRandomCard = () => {
    localStorage.removeItem('cardNum')
    localStorage.removeItem('cardUid')
    localStorage.removeItem('cardImage')
    this.setState({createdImage: null, uid: null})

    var num = 0;
    if(this.state.card == null) {
      num = Math.floor(Math.random() * (16 - 1) + 1);
    } else {
      num = this.state.card;
      num++;
      if(num > 16) num = 1;
    }

    console.log('num', cardsNums[num]);

    window.ga('send', 'event', 'link', 'click', 'Get random card');
    
    this.setState({
      card: num,
    })
  }

  clickShare = (name) => {
    this.setState({soc: name})
    window.ga('send', 'event', 'link', 'click', 'Socnet share ' + name);
  }

  clickSocnet = (name) => {

    window.ga('send', 'event', 'link', 'click', 'Socnet auth ' + name);

    window.openerState = this.state;

    this.setState({soc: name})

    var url = '';
    var protocol = window.location.protocol.replace(':', '')
    switch(name) {
      case 'VK': url = `https://master.mirbackend.huskyjam.com/login/vk-oauth2?next=/${protocol}/redirect/`; break;
      case 'FB': url = `https://master.mirbackend.huskyjam.com/login/facebook?next=/${protocol}/redirect/`; break;
      case 'OK': url = `https://master.mirbackend.huskyjam.com/login/odnoklassniki-oauth2?next=/${protocol}/redirect/`; break;
    }
    // switch(name) {
    //   case 'VK': url = `https://master.mirbackend.huskyjam.com/login/vk-oauth2?next=/local/redirect/example/`; break;
    //   case 'FB': url = `https://master.mirbackend.huskyjam.com/login/facebook?next=/login/local/example/`; break;
    //   case 'OK': url = `https://master.mirbackend.huskyjam.com/login/odnoklassniki-oauth2?next=/local/redirect/example/`; break;
    // }

    socWin = window.open(url,'','toolbar=0,status=0,width=626,height=436');

    var interval = window.setInterval(() => {
      try {
        if (socWin === null || socWin.closed) {
          window.clearInterval(interval);
          this.checkShare();
        }
      } catch (e) {
        console.error(e);
      }
    }, 1000);

  }

  clickSocnetVK = (e) => {
    e.preventDefault();
    window.socnet = 'VK';
    this.clickSocnet('VK');
  }

  clickSocnetFB = (e) => {
    e.preventDefault();
    window.socnet = 'FB';
    this.clickSocnet('FB');
  }

  clickSocnetOK = (e) => {
    e.preventDefault();
    window.socnet = 'OK';
    this.clickSocnet('OK');
  }

  createCard = () => {

    console.log('createCard');

    const { name, card, createdImage, nameVal, random } = this.state
    this.setState({ name: nameVal })

    if (nameVal) {
      axios.post(`${baseHusky}/m/create/`, {
        card_number: cardsNums[card],
        name: nameVal
      }).then(res => {
        console.log(res)
        const uid = res.data.uid
        const image = res.data.image

        console.log(card);

        localStorage.setItem('cardNum', cardsNums[card])
        localStorage.setItem('cardUid', uid)
        localStorage.setItem('cardImage', image)
        this.setState({createdImage: image, uid})
      })
    }
    window.ga('send', 'event', 'button', 'click', 'create card');

  }

  changeHandler = (option) => {
    console.log(option.value);
    this.setState({ nameVal: option.value }, () => { 
      console.log(this.state.nameVal);
      this.createCard()
    })
  }

  render() {
    const { card, name, nameVal, animated, createdImage, token, uid, random } = this.state
    const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`
    const downloadUrl = uid ? `${baseHusky}/m/${uid}/d/` : `${baseHusky}/m/2${card}/d/?${random}`
    console.log('shareUrl', shareUrl)

    const customStyles = {
      container: (provided, state) => ({
        ...provided,
        width: '100%',

      }),
      control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        borderTop: state.isFocused ? 0 : 0,
        borderLeft: state.isFocused ? 0 : 0,
        borderRight: state.isFocused ? 0 : 0,
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        '&:hover': {
          borderTop: state.isFocused ? 0 : 0,
          borderLeft: state.isFocused ? 0 : 0,
          borderRight: state.isFocused ? 0 : 0,
        },
        borderBottom: '1px solid #fff',
        borderColor: '#fff',
        minHeight: 34,
        background: 'transparent',
        width: '100%',

      }),
      indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
      }),
      input: (provided, state) => ({
        ...provided,
        height: 34,
        width: '100%',
        color: '#fff',

      }),
      singleValue: (provided, state) => ({
        ...provided,
        marginTop: 4,
        color: '#fff',
      }),
      valueContainer: (provided, state) => ({
        ...provided,
        padding: '0',
        lineHeight: '27px',
        fontSize: '19px',
        color: '#fff',
        fontFamily: 'PT Sans',
      }),
      placeholder: (provided) => ({
        ...provided,
        color: '#21ffb3',
        opacity: 0.5,
      }),
      menu: (provided, state) => ({
        ...provided,
        border: 'none',
        background: '#FFFFFF',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '0',
        marginLeft: '-10px',
        marginRight: '-10px',
        width: 'calc(100% + 20px)',
        zIndex: 101
      }),
      option: (provided) => ({
        ...provided,
        lineHeight: '27px',
        fontSize: '19px',
        color: '#00744e',
        fontFamily: 'PT Sans',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: 0,
        display: 'none'
      })
    }
    return (
      <div>
        <div style={{position: 'absolute', display: 'none'}}>
          <img src={c21}/>
          <img src={c22}/>
          <img src={c23}/>
          <img src={c24}/>
          <img src={c25}/>
          <img src={c26}/>
          <img src={c27}/>
          <img src={c28}/>
          <img src={c29}/>
          <img src={c210}/>
          <img src={c211}/>
          <img src={c212}/>
          <img src={c213}/>
          <img src={c214}/>
          <img src={c215}/>
          <img src={c216}/>
        </div>
        <Leafs></Leafs>
        <div className={`card__page ${animated ? 'animated' : ''}`}>
          <div className="card__left">
            <h2>До победы <br />один пас!</h2>

            <div className="card__name">
              <Select
                placeholder="Можно добавить имя"
                options={names}
                name="names"
                styles={customStyles}

                onChange={(option) => this.changeHandler(option)}
                onFocus={() => this.setState({ focused: true })}
                onBlur={() => this.setState({ focused: false })}
                isSearchable={true}
              />
              {/*<input className={`${name.length ? 'active' : ''}`} value={name} onChange={this.changeHandler} placeholder="Можно добавить имя" />*/}
            </div>
            <div className={`postcard postcard--${card} wobble`} key={card}>
              {createdImage ?
                <img src={createdImage} alt="" /> :
                <img src={cards[card]} alt="" />
              }
            </div>

            <div className="card__more">
              <button className="button--more" onClick={this.getRandomCard}>Хочу другую открытку</button>
            </div>
          </div>

          <div className="card__right">
            <h2>До победы <br />один пас!</h2>
            <p>Теперь у&nbsp;тебя есть классная открытка. Отправь ее&nbsp;своим близким и&nbsp;прими участие в&nbsp;розыгрыше: возможно, именно вы, 24&nbsp;марта поедете в&nbsp;Казахстан и&nbsp;будете болеть за&nbsp;нашу сборную в&nbsp;матче отборочного тура Чемпионата Европы-2020! </p>

            { token && token !== 'null' ?
              <div className="social social__share">
                <span onClick={(e) => this.clickShare('VK')}><VKShareButton url={shareUrl} image={createdImage ? createdImage : cards[card]} title="Зафутболь открытку к 8 марта" onShareWindowClose={this.checkShare}>
                  <VKIcon round={true}
                          iconBgStyle={{ fill: 'transparent' }}></VKIcon>
                </VKShareButton></span>
                <span onClick={(e) => this.clickShare('FB')}><FacebookShareButton  url={shareUrl} onShareWindowClose={this.checkShare}>
                  <FacebookIcon round={true}
                                iconBgStyle={{ fill: 'transparent' }}></FacebookIcon>
                </FacebookShareButton></span>
                <span onClick={(e) => this.clickShare('OK')}><OKShareButton  url={shareUrl} onShareWindowClose={this.checkShare}>
                  <OKIcon round={true}
                          iconBgStyle={{ fill: 'transparent' }}></OKIcon>
                </OKShareButton></span>
              </div>
            :
              <div className="social__wrapper">
                <div className="social social__login">
                  <a href="#" onClick={this.clickSocnetVK}>
                    <VKIcon round={true}
                            iconBgStyle={{ fill: 'transparent' }}></VKIcon>
                  </a>
                  <a href="#" onClick={this.clickSocnetFB}>
                    <FacebookIcon round={true}
                                  iconBgStyle={{ fill: 'transparent' }}></FacebookIcon>
                  </a>
                  <a href="#" onClick={this.clickSocnetOK}>
                    <OKIcon round={true}
                            iconBgStyle={{ fill: 'transparent' }}></OKIcon>
                  </a>
                </div>
                {createdImage ?
                  <a href={downloadUrl} className="download" target="_blank">Сохранить открытку</a> :
                  <a href={downloadUrl} className="download" target="_blank">Сохранить открытку</a>
                }
              </div>
            }

          </div>

          <div className="card__note">*В розыгрыше могут принимать участие пользователи старше 18 лет</div>
        </div>
      </div>
    );
  }
}

export default withRouter(Card);